import { Howl } from "howler";

export type SoundName = "place" | "turn" | "turn2" | "win";

/**
 * Thin wrapper around Howler. Drop audio files in `public/audio/` and register
 * them at startup, e.g. `audio.register("place", "/audio/place.webm")`.
 * Playback is a no-op until a sound is registered.
 */
class AudioManager {
  private readonly sounds = new Map<SoundName, Howl>();
  private muted = false;

  register(name: SoundName, src: string): void {
    this.sounds.set(name, new Howl({ src: [src], preload: true }));
  }

  play(name: SoundName): void {
    if (this.muted) return;
    this.sounds.get(name)?.play();
  }

  setMuted(muted: boolean): void {
    this.muted = muted;
  }
}

export const audio = new AudioManager();
